import { Flex, Text } from "@chakra-ui/react";

export const PREVIEW_BANNER_HEIGHT = 12;

export function PreviewBanner() {
  return (
    <Flex
      pos={"fixed"}
      left={0}
      right={0}
      zIndex={2}
      top={0}
      bg={"indigo.100"}
      color={"#213A6A"}
      h={PREVIEW_BANNER_HEIGHT}
      align={"center"}
      justify={"center"}
    >
      <Text fontSize={{ base: "md", md: "lg" }}>
        You&apos;re in <strong>preview mode. </strong>Some features may be
        limited.
      </Text>
    </Flex>
  );
}
